/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { TextField } from "@mui/material";

interface ICustomInputTextFieldProps {
    label: string;
    type: string;
    inputProps: any;
    value: string | number;
    onChange: (e: any) => void;
    error: any;
    helperText: any;
    fullWidth: boolean;
    margin: string;
    required: boolean;
}

export default function CustomInputTextField({ label, type, inputProps, value, onChange, error, helperText }: ICustomInputTextFieldProps) {
    if (type === 'number') {
        return (
            <TextField
                label={label}
                type="number"
                inputProps={inputProps}
                value={String(value).length > 0 ? String(value) : ''}
                onChange={onChange}
                error={!!error[label]}
                helperText={helperText[label]}
                fullWidth
                margin="dense"
                required
            />
        )
    }

    return (
        <TextField
            label={label}
            type={type}
            value={value}
            onChange={onChange}
            error={error[label]}
            helperText={helperText[label]}
            fullWidth
            margin="dense"
            required
        />
    )
}
